import React from 'react';
import cn from 'classname';
import './index.less';

import every from 'lodash/every';
import round from 'lodash/round';

import PayoutDetailsButton from '../components/payout-details-button';
import PayoutIsUrgentIcon from '../../components/payout-is-urgent-icon';
import PayoutDate from '../components/payout-date';
import PayoutStatus from '../components/payout-status';
import PayoutAffiliate from '../components/payout-affiliate';
import PayoutAmount from '../components/payout-amount';
import PayoutAmountWithPercentWrapper from '../components/payout-amount-with-percent-wrapper';
import PayoutCredentials from '../components/payout-credentials';
import PayoutActions from '../components/payout-actions';
import PayoutAction from '../components/payout-action';
import PayoutActionCanBeAllowed from '../components/payout-action-can-be-allowed';
import PayoutActionButton from '../components/payout-action-button';

import { enum as payoutStatuses } from '../../../../../../../../../../enums/payout-statuses';

function PayoutRow({ isOpen, row, payoutSystem, isToPayColumnShouldBeShown, actions, onClick }) {
	const { affiliate, payouts, payload } = row;

	const { isForbiddenToManualConfirmFromAdmin } = window.globalConfig || {};
	const isManualPayoutSystem = payoutSystem.type === 'manual';
	const {
		isInProcessing, status, is_urgent, amount, payout_percent, amount_to_pay, created_at, paid_at,
		payout_fee
	} = payload;

	return (
		<tr className={cn('payout-table--body--row', status, {
			'opened': isOpen,
			'no-paid-payouts': !affiliate.paid_payouts_count && status === payoutStatuses.pending
		})}>
			<td>
				<PayoutDetailsButton isOpen={isOpen} onClick={onClick} />
			</td>
			<td>
				<PayoutActionCanBeAllowed
					action='change-urgency'
					status={status}
				>
					{(isAllowed) => {
						const onClick = isAllowed && actions.changeUrgency.bind(null, affiliate.payout_settings.id, !is_urgent);
						return (
							<PayoutIsUrgentIcon active={is_urgent} onClick={onClick} />
						);
					}}
				</PayoutActionCanBeAllowed>
			</td>
			<td>
				<PayoutDate date={created_at} />
			</td>
			<td>
				<PayoutStatus status={status} />
			</td>
			<td>
				<PayoutAffiliate affiliate={affiliate} />
			</td>
			<td className='text-align-right'>
				<PayoutAmount
					amount={amount}
					currency={payoutSystem.currency}
					keepDecimals={payoutSystem.allow_floats}
				/>
			</td>
			{isToPayColumnShouldBeShown && (
				<td className='text-align-right'>
					{every(payouts, { payout_percent, payout_fee }) ? (
						<PayoutAmountWithPercentWrapper
							percent={payout_percent}
							isPercentShouldBeShown={payout_percent !== +payoutSystem.payout_percent}
							fee={payout_fee}
							isFeeShouldBeShown={
								payout_fee !== null && payout_fee !== +payoutSystem.payout_fee
							}
							currency={payoutSystem.currency}
						>
							<PayoutAmount
								amount={amount_to_pay}
								currency={payoutSystem.currency}
								keepDecimals={payoutSystem.allow_floats}
							/>
						</PayoutAmountWithPercentWrapper>
					) : (
						<div>-</div>
					)}
				</td>
			)}
			<td>
				<PayoutCredentials
					affiliate={affiliate}
					payoutStatus={status}
					payoutSystem={payoutSystem}
				/>
			</td>
			<td>
				{paid_at && (
					<PayoutDate date={paid_at} />
				)}
			</td>
			<td className='text-align-right'>
				{affiliate.paid_payouts_count}
			</td>
			<td className='text-align-right'>
				{round(affiliate.app, 1)}
			</td>
			<td>
				<PayoutActions>
					<PayoutAction column={1} processing={isInProcessing}>
						<PayoutActionCanBeAllowed
							action='approve'
							status={status}
						>
							{(isAllowed) => isAllowed && (
								<PayoutActionButton
									onClick={() => actions.approve(payouts)}
								>
									Approve All
								</PayoutActionButton>
							)}
						</PayoutActionCanBeAllowed>
						<PayoutActionCanBeAllowed
							action='confirm'
							status={status}
						>
							{(isAllowed) => isAllowed && (
								<PayoutActionButton
									onClick={() => actions.confirm(payouts)}
									isDisabled={isForbiddenToManualConfirmFromAdmin && isManualPayoutSystem}
								>
									Confirm All
								</PayoutActionButton>
							)}
						</PayoutActionCanBeAllowed>
					</PayoutAction>
					<PayoutAction column={2} processing={isInProcessing}>
						<PayoutActionCanBeAllowed
							action='partial'
							status={status}
						>
							{(isAllowed) => isAllowed && (
								<PayoutActionButton
									onClick={() => actions.confirm(payouts, { partially: true })}
									isDisabled={isForbiddenToManualConfirmFromAdmin && isManualPayoutSystem}
								>
									Partial
								</PayoutActionButton>
							)}
						</PayoutActionCanBeAllowed>
					</PayoutAction>
					<PayoutAction column={3} processing={isInProcessing}>
						<PayoutActionCanBeAllowed
							action='reject'
							status={status}
						>
							{(isAllowed) => isAllowed && (
								<PayoutActionButton
									onClick={() => actions.reject(payouts)}
								>
									Reject All
								</PayoutActionButton>
							)}
						</PayoutActionCanBeAllowed>
					</PayoutAction>
				</PayoutActions>
			</td>
		</tr>
	);
}

export default PayoutRow;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/table/components/payout-body/payout-row/index.js